module.exports = __webpack_public_path__ + "static/media/Icon - employees.1345e760.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - employees.svg
// module id = 161
// module chunks = 0